const metricsMiddleware = ({
    watchedActions,
    onPromptShown,
}) => () => (next) => (action) => {
    const { type } = action
    if (watchedActions[type] !== undefined) {
        const promptShownArgs = watchedActions[type](action)
        onPromptShown(promptShownArgs)
    }
    return next(action)
}

export default metricsMiddleware
